/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Otp_Verifybutton1Inputs */

const he_auth_otp_verifybutton1 = /** @type {(inputs: Auth_Otp_Verifybutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אמת והתחבר`)
};

const en_auth_otp_verifybutton1 = /** @type {(inputs: Auth_Otp_Verifybutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify and sign in`)
};

/**
* | output |
* | --- |
* | "Verify and sign in" |
*
* @param {Auth_Otp_Verifybutton1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_otp_verifybutton1 = /** @type {((inputs?: Auth_Otp_Verifybutton1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Otp_Verifybutton1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_otp_verifybutton1(inputs)
	return en_auth_otp_verifybutton1(inputs)
});
export { auth_otp_verifybutton1 as "auth_otp_verifyButton" }